var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("table", { staticClass: "table--small" }, [
    _c("thead", [
      _c("tr", [
        _c("th", { staticStyle: { width: "120px", "min-width": "12px" } }, [
          _vm._v(_vm._s(_vm.layerType.layer_type.name)),
        ]),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "100px", "min-width": "100px" } }, [
          _vm._v(
            _vm._s(_vm.$t("placementtype." + _vm.layerType.placement_type))
          ),
        ]),
        _vm._v(" "),
        _c("th", [
          _vm._v(
            _vm._s(_vm.layerType.subtype) +
              " " +
              _vm._s(_vm.layerType.thickness) +
              " " +
              _vm._s(_vm.$t("cm"))
          ),
        ]),
        _vm._v(" "),
        _c(
          "th",
          {
            staticClass: "text-right",
            staticStyle: { width: "100px", "min-width": "100px" },
          },
          [
            _vm._v(
              _vm._s(_vm.$helpers.formatNumber(_vm.layerType.qm)) +
                " " +
                _vm._s(_vm.$t("qm"))
            ),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "tbody",
      _vm._l(_vm.layerLogs, function (layerLog, index) {
        return _c(
          "tr",
          { key: index },
          [
            _vm.isVisibleLayerLog(layerLog)
              ? [
                  _c(
                    "td",
                    { staticStyle: { width: "120px", "min-width": "120px" } },
                    [
                      _c("span", { staticClass: "table-status" }, [
                        _c("span", {
                          staticClass: "status-icon",
                          class: "status-icon--" + layerLog.status,
                        }),
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t("status." + layerLog.status + "_short")
                            ) +
                            "\n          "
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    { staticStyle: { width: "125px", "min-width": "125px" } },
                    [
                      layerLog.status === "open"
                        ? [
                            _vm._v(
                              _vm._s(_vm.$helpers.formatNumber(layerLog.qm)) +
                                " " +
                                _vm._s(_vm.$t("qm"))
                            ),
                          ]
                        : [
                            !_vm.isVisibleLayerLogUpdate(layerLog)
                              ? [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$helpers.formatNumber(layerLog.qm)
                                      ) +
                                      " " +
                                      _vm._s(_vm.$t("qm")) +
                                      "\n              "
                                  ),
                                  _vm.$store.getters.userHasPermission(
                                    "project_qm_update"
                                  ) && !_vm.isCancelled
                                    ? [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "button button--action button--action--edit button--small",
                                            attrs: {
                                              role: "button",
                                              title: _vm.$t("update"),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.onUpdateLayerLog(
                                                  layerLog
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.$t("update")))]
                                        ),
                                      ]
                                    : _vm._e(),
                                ]
                              : [
                                  _vm.$store.getters.userHasPermission(
                                    "project_qm_update"
                                  ) && !_vm.isCancelled
                                    ? [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: layerLog.qm,
                                              expression: "layerLog.qm",
                                            },
                                          ],
                                          staticClass:
                                            "form-control form-control--extra-small",
                                          attrs: {
                                            type: "text",
                                            placeholder: _vm.$t(
                                              "form.project.layer.log.area.plc"
                                            ),
                                          },
                                          domProps: { value: layerLog.qm },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.$set(
                                                layerLog,
                                                "qm",
                                                $event.target.value
                                              )
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "button button--action button--action--delete button--small",
                                            attrs: {
                                              role: "button",
                                              title: _vm.$t("delete"),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.onDeleteLayerLog(
                                                  layerLog
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.$t("delete")))]
                                        ),
                                      ]
                                    : _vm._e(),
                                ],
                          ],
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    { staticClass: "text-right", attrs: { colspan: "2" } },
                    [
                      layerLog.status === "open"
                        ? [
                            _vm.$store.getters.userHasPermission(
                              "project_qm_update"
                            ) && !_vm.isCancelled
                              ? [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "grid-x grid-margin-x align-right",
                                    },
                                    [
                                      _c("div", { staticClass: "cell" }, [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "button button--save button--extra-small",
                                            attrs: {
                                              role: "button",
                                              title: _vm.$t("form.submit.save"),
                                            },
                                            on: {
                                              click: _vm.onOpenFinishReveal,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("form.submit.save"))
                                            ),
                                          ]
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "cell form-group" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.layerValue.qm,
                                                expression: "layerValue.qm",
                                              },
                                            ],
                                            staticClass:
                                              "form-control form-control--extra-small",
                                            attrs: {
                                              type: "text",
                                              placeholder: _vm.$t(
                                                "form.project.layer.log.area.plc"
                                              ),
                                            },
                                            domProps: {
                                              value: _vm.layerValue.qm,
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.layerValue,
                                                  "qm",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "cell form-group" },
                                        [
                                          _c("v-datepicker", {
                                            staticClass:
                                              "form-control form-control--extra-small form-control--date",
                                            attrs: {
                                              format: _vm.$helpers.dateFormat,
                                              disabledDates: {
                                                from: new Date(),
                                              },
                                            },
                                            model: {
                                              value: _vm.layerValue.date.date,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.layerValue.date,
                                                  "date",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "layerValue.date.date",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ]
                              : _vm._e(),
                          ]
                        : layerLog.date.date !== null
                        ? [
                            _vm._v(
                              _vm._s(
                                _vm._f("moment")(
                                  layerLog.date.date,
                                  _vm.$helpers.dateFormat.toUpperCase()
                                )
                              )
                            ),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "reveal reveal--body",
                          attrs: {
                            id: "finish-object-" + _vm.layerType.id + "-reveal",
                            "data-reveal": "",
                          },
                        },
                        [
                          _c("div", { staticClass: "reveal--body__content" }, [
                            _c("h2", [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$t("form.project.layer.finish.title", {
                                      layer: _vm.layerType.layer_type.name,
                                    })
                                  ) +
                                  "\n              "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$t(
                                      "form.project.layer.finish.content",
                                      {
                                        total: _vm.$helpers.formatNumber(
                                          _vm.object.total
                                        ),
                                        finished: _vm.$helpers.formatNumber(
                                          _vm.object.finished
                                        ),
                                      }
                                    )
                                  ) +
                                  "\n              "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "form" }, [
                              _c("div", { staticClass: "form-group" }, [
                                _c("textarea", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.object.comment,
                                      expression: "object.comment",
                                    },
                                  ],
                                  staticClass: "form-control--textarea",
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "form.project.layer.log.comment.plc"
                                    ),
                                  },
                                  domProps: { value: _vm.object.comment },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.object,
                                        "comment",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "form-group" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass: "button",
                                    attrs: {
                                      role: "button",
                                      type: "submit",
                                      title: _vm.$t("form.submit.confirm"),
                                      disabled: _vm.objectFormDisabled,
                                    },
                                    on: { click: _vm.onSubmitFinishObject },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("form.submit.confirm"))
                                    ),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _vm._m(0, true),
                        ]
                      ),
                    ],
                    2
                  ),
                ]
              : _vm._e(),
          ],
          2
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "button",
      {
        staticClass: "close-button",
        attrs: {
          "data-close": "",
          "aria-label": "Close modal",
          type: "button",
        },
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }